"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactSpring = require("react-spring");
var _CTAList = _interopRequireDefault(require("../CTAList"));
var _Text = _interopRequireDefault(require("../Text"));
var _index = _interopRequireWildcard(require("./index.styled"));
var _LinkItem = _interopRequireDefault(require("./LinkItem"));
var _jsxRuntime = require("react/jsx-runtime");
const DesktopNavigation = function (_ref) {
  let {
    className,
    subnavTitle,
    titleHref,
    titleTarget,
    titleAriaLabel,
    links = [],
    theme,
    ctas = [],
    activeLink,
    onClick,
    selectedUnderlineColor,
    titleClick = function () {},
    showBuildCTA
  } = _ref;
  const activeLinkProp = {};
  const underlinePosition = {
    width: activeLinkProp.offsetWidth || 0,
    left: activeLinkProp.offsetLeft || 0,
    opacity: 1
  };
  const underlineProps = (0, _reactSpring.useSpring)({
    from: {
      opacity: 0,
      width: 0,
      left: 0
    },
    to: {
      ...underlinePosition,
      opacity: 1
    }
  });
  const AnimatedUnderline = (0, _reactSpring.animated)(_index.default.Underline);
  const isCTAVisible = function () {
    return showBuildCTA === true && ctas.length > 0;
  };
  const animatedUnderlineProps = {
    style: underlineProps,
    as: _index.default.LinkItemUnderline
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ThemeProvider, {
    theme: {
      theme,
      selectedUnderlineColor
    },
    "data-testid": "DesktopNavigation",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.PageNavigation, {
      className: className,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Container, {
        children: [subnavTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Model, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ModelButton, {
            href: titleHref,
            target: titleTarget,
            onClick: titleClick,
            ...(titleAriaLabel && {
              "aria-label": titleAriaLabel
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: subnavTitle
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.RightContainer, {
          children: !selectedUnderlineColor ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.LinksScrollWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Links, {
              children: [links.map(function (link, index) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkItem.default, {
                  active: activeLink === index,
                  onClick: onClick === null || onClick === void 0 ? void 0 : onClick(link.href, index),
                  selectedUnderlineColor: selectedUnderlineColor,
                  "data-testid": "DesktopNavigation",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Link, {
                    id: `${index}Link`,
                    href: link.href,
                    target: link.target,
                    selectedUnderlineColor: selectedUnderlineColor,
                    ...(link.target === "_blank" && {
                      role: "noopener"
                    }),
                    ...(link.ariaLabel && {
                      "aria-label": link.ariaLabel
                    }),
                    children: link.text
                  })
                }, `${link.href}-${index}`);
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AnimatedUnderline, {
                ...animatedUnderlineProps
              })]
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Links, {
            children: [links.map(function (link, index) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkItem.default, {
                active: activeLink === index,
                onClick: onClick === null || onClick === void 0 ? void 0 : onClick(link.href, index),
                selectedUnderlineColor: selectedUnderlineColor,
                "data-testid": "DesktopNavigation",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Link, {
                  id: `${index}Link`,
                  href: link.href,
                  target: link.target,
                  selectedUnderlineColor: selectedUnderlineColor,
                  ...(link.target === "_blank" && {
                    role: "noopener"
                  }),
                  ...(link.ariaLabel && {
                    "aria-label": link.ariaLabel
                  }),
                  children: link.text
                })
              }, `${link.href}-${index}`);
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AnimatedUnderline, {
              ...animatedUnderlineProps
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Button, {
          style: {
            opacity: isCTAVisible() ? "1" : "0",
            visibility: isCTAVisible() ? "visible" : "hidden",
            transition: "visibility 0s linear 0s, opacity 100ms ease"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CTAList.default, {
            size: "small",
            ctas: ctas
          })
        })]
      })
    })
  });
};
var _default = exports.default = DesktopNavigation;